<template>
  <form @submit.prevent="updateProfile()" class="form">
    <div class="profile">
      <div class="profile__col1">
        <h2 class="heading-tertiary">{{ $t('parameters.profil.avatar') }}</h2>
        <div class="profile__image-box" id="dropZone" @dragover.prevent="onDragOver" @drop.stop.prevent="onDrop" @dragleave="onDragLeave">
          <img class="profile__image" :src="imageURL">
          <label for="imageUpload" class="u-pointer" style="align-self:flex-start">
            <svg class="profile__icon profile__icon--small u-valign-middle">
              <use href="../assets/sprite.svg#icon-folder"></use>
            </svg>
            {{ $t('parameters.profil.upload') }}
          </label>
          <input type="file" id="imageUpload" @change="uploadImage">
        </div>
        <h2 class="heading-tertiary">{{ $t('parameters.profil.password') }}</h2>
        <div class="profile__password-box">
          <Entry typeField='password' v-model="password" :autoSave="true" :maskOnValue='hasToBeAValidPassword' indicator="form.newPassword"></Entry>
          <Entry typeField='password' v-model="confirmPassword" :autoSave="true" :hasToCompare="true" :compareValue='hasToBeAMatchPassword(password,confirmPassword)' indicator="form.confirmPassword"></Entry>
        </div>
      </div>
      <div class='profile__col2'>
        <h2 class="heading-tertiary">{{ $t('parameters.profil.infos') }}</h2>
        <div class="profile__infos-box">
          <div class="form__grouprow">
            <Entry v-model="name" :autoSave="true" required indicator="form.name"/>
            <Entry v-model="firstname" :autoSave="true" required indicator="form.firstname"/>
          </div>
          <Entry v-model="email" :autoSave="true" required :maskOnValue='hasToBeAnEmail' indicator="form.email"></Entry>
          <div class="form__grouprow">
            <Entry v-model="directNumber" :autoSave="true" :maskOnKey='hasToBeANumber' indicator="form.directNumber"></Entry>
            <Entry v-model="internalNumber" :autoSave="true" :maskOnKey='hasToBeANumber' indicator="form.internalNumber"></Entry>
          </div>
          <div class="form__grouprow">
            <Entry v-model="mobileNumber" :autoSave="true" :maskOnKey='hasToBeANumber' indicator="form.mobileNumber"></Entry>
            <Entry v-model="skype" :autoSave="true" :maskOnValue='hasToBeAnEmail' indicator="form.skype"></Entry>
          </div>
        </div>
        <div>
          <h2 class="heading-tertiary">{{ $t('parameters.profil.society') }}</h2>
          <div class="profile__company-box">
            <Entry v-model="companyName" :autoSave="true" indicator="form.companyName"></Entry>
            <Entry v-model="companyAddress" :autoSave="true" indicator="form.companyAddress"></Entry>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { HTTP_CLIENT } from '../axios-wrapper'
import { toastMixin } from '../components/Mixins/Toast'
import { formMixin } from '../components/Mixins/Form'
import Entry from '../components/Entry'

const { mapGetters, mapMutations } = createNamespacedHelpers('user')

export default {
  data: function () {
    return {
      imageURL: '',
      objFile: '',
      srcData: '',
      storeWatcher: undefined,
      // showSaveProfile: false,
      dialogBoxSave: {
        title: this.$t('dialog.user.update.title'),
        content: this.$t('dialog.user.update.content'),
        cancelAction: this.$t('dialog.user.update.cancelAction'),
        confirmAction: this.$t('dialog.user.update.confirmAction'),
        default: 'confirm'
      },

      name: '',
      firstname: '',
      email: '',
      directNumber: '',
      internalNumber: '',
      mobileNumber: '',
      skype: '',
      password: '',
      confirmPassword: '',
      companyName: '',
      companyAddress: ''
    }
  },
  components: {
    Entry
  },
  mixins: [formMixin, toastMixin],
  mounted: function () {
    this.getProfile()
    this.$store.dispatch('user/GET_AVATAR', this.userId)
      .then(response => { this.imageURL = response.data })
      .catch(() => { this.imageURL = require('../assets/user.png') })
  },
  computed: {
    ...mapGetters({
      userId: 'getUserId',
      userName: 'getUserName',
      userFirstname: 'getUserFirstname'
    })
  },
  methods: {
    ...mapMutations({
      setName: 'SET_USER_NAME',
      setFirstName: 'SET_USER_FIRSTNAME',
      setAvatar: 'SET_AVATAR'
    }),
    async getProfile () {
      try {
        const { data } = await HTTP_CLIENT.get(`user/${this.userId}`)
        const { email, name, firstname, directNumber, internalNumber, mobileNumber, skype, companyName, companyAddress } = data
        this.srcData = data
        this.name = name
        this.firstname = firstname
        this.email = email
        this.directNumber = directNumber
        this.internalNumber = internalNumber
        this.mobileNumber = mobileNumber
        this.skype = skype
        this.companyName = companyName
        this.companyAddress = companyAddress
      } catch (error) { console.log(error) }
    },
    async updateProfile () {
      // Au moins une entry a un attribut not valid ?
      if (this.$el.querySelectorAll('[data-entry-not-valid]').length) return

      const { name, firstname, email, directNumber, internalNumber, mobileNumber, skype, companyName, companyAddress, password, confirmPassword } = this
      // ---------------------- Mise à jour du profil utilisateur ( saisies ) ---------------------------
      let infos = `{
        "name": "${name}",
        "firstname": "${firstname}",
        "directNumber": "${directNumber}",
        "internalNumber": "${internalNumber}",
        "mobileNumber": "${mobileNumber}",
        "skype": "${skype}",
        "companyName": "${companyName}",
        "companyAddress": "${companyAddress}",
        "email": "${email}"`

      if (password.trim().length > 0 && confirmPassword.trim().length > 0) infos += `,"password": "${password}"`
      infos += '}'

      let repError = false

      try {
        const { data } = await HTTP_CLIENT.patch(`user/${this.userId}`, JSON.parse(infos))
        this.srcData = data
        this.setName(name)
        this.setFirstName(firstname)
        this.sendSuccessToast(this.$t('feedback-ok.user.profil'))
      } catch (error) {
        this.sendErrorToast(this.$t('feedback-err.user.profil'))
        repError = true
      }

      // ------------------------ Mise à jour du profil utilisateur ( avatar ) --------------------------
      if (this.objFile && this.objFile.name !== this.srcData.avatar) {
        let formData = new FormData()
        formData.append('imageUpload', this.objFile)

        try {
          const { data } = await HTTP_CLIENT.patch(`user/avatar/${this.userId}`,
            formData,
            {
              headers: { 'Content-Type': 'multipart/form-data' },
              onUploadProgress (progressEvent) { console.log({ progressEvent }) }
            })
          this.setAvatar(data)
          this.sendSuccessToast(this.$t('feedback-ok.user.avatar'))
          this.srcData.avatar = this.objFile.name
        } catch (error) {
          this.sendErrorToast(this.$t('feedback-err.user.avatar'))
          repError = true
        }
      }
      if (!repError) this.$store.commit('entry/UPDATE_ASK_FOR_SAVE_ON_QUIT', false)
      return !repError
    },
    uploadImage (event) {
      this.imageURL = URL.createObjectURL(event.target.files[0])
      this.objFile = event.target.files[0]
    },
    onDrop (event) {
      this.imageURL = URL.createObjectURL(event.dataTransfer.files[0])
      this.objFile = event.dataTransfer.files[0]
      document.getElementById('dropZone').style.border = 'none'
    },
    onDragOver (event) {
      document.getElementById('dropZone').style.border = '1px dashed #01587F'
    },
    onDragLeave (event) {
      event.target.style.border = 'none'
    }
  },
  async created () {
    // remonté de la fn exposé pour la demande de svg si prof modifié
    this.$store.commit('entry/UPDATE_SAVE_ON_QUIT', {
      title: this.$t('dialog.user.update.title'),
      content: this.$t('dialog.user.update.content'),
      fn: this.updateProfile })

    // Ajout des icone de la vue ds la toolbar
    let toolbarIconsID = await this.$store.dispatch('subheader/ADD_ICON_TOOLBAR', [{
      svg: 'icon-checkmark',
      fn: this.updateProfile }])
    this.toolbarIconsID = toolbarIconsID
  },
  destroyed () {
    this.$store.commit('subheader/REMOVE_ICON_TOOLBAR', this.toolbarIconsID)
    this.$store.commit('entry/UPDATE_SAVE_ON_QUIT', undefined)
  }
}
</script>
